import classnames from 'classnames';
import createReactClass from 'create-react-class';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Button from 'components/common/button';

const AttachmentButton = createReactClass({
  propTypes: {
    allowedFileTypes: PropTypes.string,
    buttonText: PropTypes.string,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    multiple: PropTypes.bool,
    onAttach: PropTypes.func.isRequired,
    onAttachBlur: PropTypes.func,
  },

  getDefaultProps() {
    return {
      multiple: true,
      labelClassName: 'draftStylesMenu-item',
    };
  },

  focus() {
    this.button.focus();
  },

  onAttach(event) {
    this.input.click();
    event.preventDefault();
  },

  render() {
    return (
      <label key="label" className={this.props.labelClassName} title="Attachment">
        <input
          accept={this.props.allowedFileTypes}
          className="attachmentInput"
          multiple={this.props.multiple}
          onChange={this.props.onAttach}
          ref={input => (this.input = input)}
          style={{ display: 'none' }}
          type="file"
        />
        <StyledAttachmentButton
          className={classnames({ 'fa fa-paperclip fa-flip-horizontal': !this.props.buttonText }, this.props.className)}
          onBlur={this.props.onAttachBlur}
          onClick={this.onAttach}
          ref={button => (this.button = button)}
          tabIndex="-1"
        >
          {this.props.buttonText}
        </StyledAttachmentButton>
      </label>
    );
  },
});

export const StyledAttachmentButton = styled(Button)`
  background: transparent;
  border: none;
  color: inherit;
  height: 25px;
  padding: 0;
  width: 25px;
  &:focus {
    border: 1px solid ${p => p.theme.colors.gray200};
    border-radius: 4px;
  }
  &:hover {
    background: transparent;
  }
`;

export default AttachmentButton;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/lib/attachment/attachment_button.jsx